import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Sparkles, Construction } from "lucide-react";
import { api } from "../../../lib/auth";

export default function GenericDashboard() {
  const { kind } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/t/dashboard/${kind}`).then((r) => setData(r.data)).catch(() => setData({ title: "Dashboard", stats: [] }));
  }, [kind]);

  if (!data) return <div className="p-8 text-black/50">Loading...</div>;

  const toneMap = {
    yellow: "bg-[#FFF9E6]", mint: "bg-[#E8F5E9]", pink: "bg-[#FFE4E8]",
    blue: "bg-blue-50", red: "bg-red-50",
  };

  return (
    <div data-testid={`generic-dashboard-${kind}`} className="p-6 lg:p-8">
      <h1 className="font-display font-extrabold text-2xl md:text-3xl text-black tracking-tight">{data.title}</h1>
      <p className="text-sm text-black/60 mt-0.5">High-level overview of this module.</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
        {data.stats.map((s, i) => (
          <div key={i} className={`${toneMap[s.tone] || "bg-white"} rounded-2xl p-5 border border-black/5`}>
            <div className="text-xs text-black/60 font-medium">{s.label}</div>
            <div className="font-display font-extrabold text-3xl text-black mt-1.5 tracking-tight">{s.value}</div>
          </div>
        ))}
      </div>

      <div className="mt-7 bg-white rounded-2xl border border-black/8 p-9 text-center">
        <div className="w-14 h-14 rounded-2xl bg-[#FFF9E6] flex items-center justify-center mx-auto mb-4">
          <Construction size={26} className="text-amber-700" />
        </div>
        <h2 className="font-display font-bold text-xl text-black">Module coming soon</h2>
        <p className="text-sm text-black/60 mt-2 max-w-md mx-auto">
          The full feature set for this module is on our roadmap. Talk to your account manager for early access.
        </p>
        <div className="mt-6 inline-flex items-center gap-1.5 text-xs text-black/50 px-3 py-1.5 rounded-full bg-[#FFFCF2] border border-black/10">
          <Sparkles size={12} /> Phase 2 release
        </div>
      </div>
    </div>
  );
}
